import React, { useState, useEffect, useRef } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { Form, Button, Col, Row, Spinner } from 'react-bootstrap';
import { FaRegTrashAlt, FaAngleUp, FaAngleDown } from "react-icons/fa";
import { RiAddBoxLine } from "react-icons/ri";
import PayMethodCrudService from '../../../services/PayMethodCrudService';

const TabMethodImages = ({ tempImages, setTempImages, setCloseButton, codeMethod, isViewOrDelete, handleClose, enableChangeImage, setEnableChangeImage, selectedImages, setSelectedImages, setSuccessMessage }) => {

    const NERTHUS = process.env.REACT_APP_NERTHUS_API_URL + '/images';
    const arrayImagesRef = useRef(null);
    const [deletedImages, setDeletedImages] = useState([]);

    function sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time))
    }

    const DeleteImage = (index) => {

        alert('!Se ha Eliminado¡ ' + index);
        const image = selectedImages[index];
        if (image) {
            delete selectedImages[index];
            setSelectedImages({ ...selectedImages });
        }

        setDeletedImages(deletedImages => [...deletedImages, tempImages[index]]);
        const newTempImages = [...tempImages];
        newTempImages.splice(index, 1);

        setTempImages(newTempImages);

        setEnableChangeImage(false);
    };

    const scrollToBottom = () => {
        if (arrayImagesRef.current && tempImages.length > 0) {
            const scrollOffset = (arrayImagesRef.current.scrollHeight) - (arrayImagesRef.current.clientHeight - 100);

            arrayImagesRef.current.scrollTo({
                top: scrollOffset,
                behavior: 'smooth'
            });

        }
    };

    const setAddNewImage = () => {
        if (tempImages.length >= 5) {
            return;
        }
        setTempImages(tempImages => [...tempImages, '/default/default.jpg']);
        setTimeout(scrollToBottom, 0);
    }


    const handleImageSubmit = async () => {

        const formData = new FormData();

        Object.keys(selectedImages).forEach((name) => {
            formData.append('files[]', selectedImages[name]);
            tempImages[name] = '/paymethods/' + codeMethod + '/' + selectedImages[name].name;
        });
        formData.append('images', JSON.stringify(tempImages));
        formData.append('deletedImages', JSON.stringify(deletedImages));

        PayMethodCrudService.uploadImagesMethod(codeMethod, formData).then(res => {
            setSuccessMessage('success');
            sleep(1000).then(() => {
                handleClose();
                window.location.href = '/catalogs/paymethods';
            })
        }).catch(err => {
            console.log(err);
            if (err.response.status !== 200) {
                setSuccessMessage('danger');
            }
        });
    };

    function renderImagePreview(name, defaultValue) {
        const image = selectedImages[name];
        return image ? <img src={URL.createObjectURL(image)} alt={image.name} style={{ width: '300px' }} /> : <img src={defaultValue} alt={name} style={{ width: '300px' }} />;
    }

    function handleFileChange(event) {

        const { name } = event.target;

        const randomName = Array(4).fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16)).join('');

        let file = event.target.files[0];
        let newFile = new File([file], randomName + '.jpg', { type: file.type });
        setSelectedImages({ ...selectedImages, [name]: newFile });
        setEnableChangeImage(false);
    }

    const MoveImageUp = (index) => {
        index = parseInt(index);
        if (index > 0) {
            const newTempImages = [...tempImages];
            [newTempImages[index], newTempImages[index - 1]] = [newTempImages[index - 1], newTempImages[index]];
            setTempImages(newTempImages);
            setEnableChangeImage(false);
        }
    };

    const MoveImageDown = (index) => {
        index = parseInt(index);
        if (index < tempImages.length - 1) {
            const newTempImages = [...tempImages];
            [newTempImages[index], newTempImages[index + 1]] = [newTempImages[index + 1], newTempImages[index]];
            setTempImages(newTempImages);
            setEnableChangeImage(false);
        }
    };

    const disableAddImage = () => {
        return tempImages.length >= 5;
    }

    return (
        <div>
            <div style={{ maxHeight: '70vh', overflowY: 'auto', marginBottom: '20px' }} key={'arrayImages'} ref={arrayImagesRef}>
                {Object.entries(tempImages).map(([key, value]) => {
                    return (<div key={key}>
                        <Row className="mb-3" key={'image' + key} style={{ marginRight: '0px' }}>
                            <Form.Group as={Col} md="6" key={key} controlId={key}>
                                {!isViewOrDelete ? (<>
                                    <Form.Label>Change Image {key}</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/png,image/jpeg"
                                        name={key}
                                        placeholder="Select Image File"
                                        onChange={isViewOrDelete ? null : handleFileChange}
                                        readOnly={isViewOrDelete ? true : false}
                                        disabled={isViewOrDelete ? true : false}
                                    />
                                </>) : ('')}
                            </Form.Group>
                        </Row>
                        <Row className="mb-3" key={key + value} style={{ marginRight: '0px' }}>

                            <Form.Group as={Col} md="7" key={key + value} controlId={key + value}>
                                {renderImagePreview(key, NERTHUS + value)}
                                {!isViewOrDelete && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <span className="action-button" type='button' onClick={() => DeleteImage(key)}> <FaRegTrashAlt alt='Delete' /> Delete Image {key} </span>
                                        <span className="action-button" type='button' onClick={() => MoveImageUp(key)}> <FaAngleUp alt='Up' /> Move Up </span>
                                        <span className="action-button" type='button' onClick={() => MoveImageDown(key)}> <FaAngleDown alt='Down' /> Move Down </span>
                                    </div>
                                )}
                            </Form.Group>
                        </Row>
                        <hr></hr>
                    </div>);
                })}
                <div className="d-flex justify-content-end" style={{ float: 'right', padding: '16px', width: '320px' }}>
                    <span>  {'  '} {'  '}  Images  {tempImages.length} / 5 {'  '} {'  '}  </span>
                    <span>
                        {!isViewOrDelete ? (<>{'  '}{'  '}<Button type='button' onClick={() => setAddNewImage()} disabled={disableAddImage()}> <RiAddBoxLine alt='AddImage'/> Add Image </Button></>) : ('')}
                    </span>
                </div>
            </div>

            <div>
                {!isViewOrDelete ? (<><Button type="button" disabled={enableChangeImage} onClick={() => handleImageSubmit()}> Save Images </Button></>) : ('')}
                {'  '}{'  '}
                {setCloseButton}

            </div>
        </div>
    );

}

export default TabMethodImages;